<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 6H6M12 9H6M9.75 12H6M3 1.5V16.5L4.5 15.75L6 16.5L7.5 15.75L9 16.5L10.5 15.75L12 16.5L13.5 15.75L15 16.5V1.5L13.5 2.25L12 1.5L10.5 2.25L9 1.5L7.5 2.25L6 1.5L4.5 2.25L3 1.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
